import { Routes, Route, Navigate } from "react-router-dom";
import PlanningUpload from "./Modules/PlanningUpload";
import PlanningLoad from "./Modules/PlanningLoad";
import PlanningDetail from "./Modules/PlanningDetail";
import RestrictionRoute from "routes/RestrictionRoute";
import PlanningAssiggnment2 from "./Modules/PlanningAssiggnment2";
import MonitoringTrips from "./Modules/MonitoringTrips";
import AppointmentReport from "./Modules/AppointmentReport";
import CostReport from "./Modules/CostReport";

const Routers = ({views}) => {
  return (
    <Routes>
      <Route path="upload" element={<RestrictionRoute views={views}><PlanningUpload /></RestrictionRoute>} />
      <Route path="detail" element={<RestrictionRoute views={views}><PlanningDetail /></RestrictionRoute>} />
      <Route path="history" element={<RestrictionRoute views={views}><PlanningLoad /></RestrictionRoute>} />
      {/* <Route path="load-plan-assignment" element={<RestrictionRoute views={views}><PlanningAssiggnment /></RestrictionRoute>} /> */}
      <Route path="load-plan-assignment" element={<RestrictionRoute views={views}><PlanningAssiggnment2 /></RestrictionRoute>} />
      <Route path="monitoring-history" element={<RestrictionRoute views={views}><MonitoringTrips /></RestrictionRoute>} />
      <Route path="dating-history" element={<RestrictionRoute views={views}><AppointmentReport /></RestrictionRoute>} />
      <Route path="cost-report" element={<RestrictionRoute views={views}><CostReport /></RestrictionRoute>} />
      <Route path="*" element={<Navigate to="../upload" replace />} />
    </Routes>
  );
};

export default Routers;
